const C = require("../constants");

const expenseSelectAction = (data) => {
    return {
        type: C.EXPENSE_SELECT,
        data
    }
};

export {expenseSelectAction};


// WEBPACK FOOTER //
// ./src/actions/ExpenseSelectAction.js